import { FC, useEffect, useRef, useState } from "react";
import styles from "./ModelInfo.module.scss";
import notify from "../../images/icons/AdminPanel/notify.svg";
import { useLocation } from "react-router-dom";
import { BlockService } from "./BlockService";
import { IPhoto, IRequestPatchUser, TVerify } from "../../types/user";
import { BlockImage } from "./BlockImage";
import { BlockGeneral } from "./BlockGeneral";
import { BlockParameters } from "./BlockParameters";
import { capitalizeFirstLetter } from "../../utils/utils";
import { ModelComponent } from "../../pages/Models/Model/ModelComponent";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import { updateUser } from "../../services/slices/user";
import AvatarPopup from "./AvatarPopup";
import { PopupNotify } from "../ui/PopupNotify/PopupNotify";
import { Chat } from "../Chat/Chat";
export interface IModelInfo {
  name: string;
  photo?: string | null;
  verification: TVerify | null;
  dataImage: Array<IPhoto>;
}

export const ModelInfo: FC<IModelInfo> = ({
  name,
  photo,
  verification,
  dataImage,
}) => {
  const router = useLocation();
  const { user } = useAppSelector((state) => state.user);
  const [image, setImage] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  async function patchUserAvatar() {
    if (image) {
      const newAvatar: IRequestPatchUser = {
        profileAvatar: {
          avatarUrl: image,
        },
      };
      dispatch(updateUser(newAvatar));
    }
  }

  const handleImageRemove = () => {
    setImage(null); // Очищаем изображение
  };

  return (
    <>
      <div className={styles.Section}>
        <div className={styles.HeaderProfile}>
          <div className={styles.HeaderProfile_notify}>
            <AvatarPopup
              image={image}
              photo={photo}
              setImage={setImage}
              handleImageRemove={handleImageRemove}
              patchUserAvatar={patchUserAvatar}
            />
            <h3 className={styles.HeaderProfile_welcom}>
              Welcome, {capitalizeFirstLetter(name)}
            </h3>
          </div>
          <div>
            <PopupNotify />
          </div>
        </div>
        {!router.pathname.includes("/model-panel/chat") ? (
          <div className={styles.Information}>
            <div className={styles.Verification}>
              {verification === "approved" ? (
                <span className={styles.Verification_text}>
                  Nach Ihrer Zustimmung wird Ihr Profil zusammen mit Ihren Daten
                  und Fotos auf der Website veröffentlicht.
                </span>
              ) : (
                <span className={styles.Verification_text}>
                  Ihr Profil wird auf der Website veröffentlicht
                </span>
              )}
            </div>
            <div className={styles.Block}>
              {router.pathname === `/model-panel` && (
                <ModelComponent id={user ? user.id : 0} />
              )}
              {router.pathname === "/model-panel/intim" && <BlockService />}
              {router.pathname === "/model-panel/image" && (
                <BlockImage dataImage={dataImage} />
              )}

              {router.pathname === "/model-panel/general" && <BlockGeneral />}
              {router.pathname === "/model-panel/parameters" && (
                <BlockParameters />
              )}
            </div>
          </div>
        ) : (
          <Chat />
        )}
      </div>
    </>
  );
};
